import axios from "axios";
import { getApiBaseUrl } from "../config/apiBase";

const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    console.error("[API]", status ?? "network", url ?? "", error.message);
    return Promise.reject(error);
  }
);

export default apiClient;
